import { GET_TRANSLATIONS_SUCCESS } from '../../constants/reduxKeys';

export function setTranslations(data) {
  return {
    type: GET_TRANSLATIONS_SUCCESS,
    payload: data
  };
};

